module.exports = __webpack_public_path__ + "img/grey_anime.gif";